/**
 *
 * NOTE:
 * These values have a hard dependency on {TBD NAME of backend service}
 * @see somerepo.tbd.service.name
 * @see components.order-progress
 * @see components.status-card
 */

/* Active Order Status Events (from service) */
export const PREFIX = 'constants.status';
export const SCHEDULING = 'SCHEDULING'; // For scheduled orders
export const PENDING_SCHEDULING = 'PENDING_SCHEDULING'; // For scheduled orders
export const QUEUEING = 'QUEUEING'; // For scheduled orders
export const NEW = 'NEW';
export const PENDING_PICKUP = 'PENDING_PICKUP';
export const PICKING_UP = 'PICKING_UP'; // This may be removed in the future
export const PENDING_DROP_OFF = 'PENDING_DROP_OFF';
export const DROPPING_OFF = 'DROPPING_OFF';
export const COMPLETED = 'COMPLETED';

/* Active Order Status Events (from service) */
export const DRIVER_CANCELLED = 'DRIVER_CANCELLED';
export const SENDER_CANCELLED = 'SENDER_CANCELLED';
export const OPERATOR_CANCELLED = 'OPERATOR_CANCELLED';

export const SCHEDULE_FAILED = 'SCHEDULE_FAILED';
export const FAILED_DELIVERY = 'FAILED_DELIVERY';
export const PENDING_RETURN = 'PENDING_RETURN';
export const RETURNING = 'RETURNING';
export const RETURNED = 'RETURNED';

/* ETA Status events and messages (internally derived) */
export const ETA_THRESHOLD_IN_MINUTES = 2;
export const STATUS_MESSAGE_ITEM_PICKED_UP = 'STATUS_MESSAGE_ITEM_PICKED_UP';
export const STATUS_MESSAGE_DRIVER_IN_TRANSIT =
  'STATUS_MESSAGE_DRIVER_IN_TRANSIT';
export const STATUS_MESSAGE_DRIVER_WILL_ARRIVE_SOON =
  'STATUS_MESSAGE_DRIVER_WILL_ARRIVE_SOON';
export const STATUS_MESSAGE_DRIVER_HAS_DELIVERED_ITEM =
  'STATUS_MESSAGE_DRIVER_HAS_DELIVERED_ITEM';
export const STATUS_MESSAGE_DRIVER_HAS_ARRIVED =
  'STATUS_MESSAGE_DRIVER_HAS_ARRIVED';

// Playbook values, these are just normal constant values, not tied to any other system nor BE
/**
 * For normal booking (A.K.A non-scheduled order in BE)
 * Named as normal because there may be other types of playbook
 */
export const PLAYBOOK_TYPE_INSTANT_BOOKING = 'pb_instant_booking';
/** For anytime booking (A.K.A scheduled order in BE) */
export const PLAYBOOK_TYPE_ANYTIME_BOOKING = 'pb_anytime_booking';

// States of GrabExpress
// https://wiki.grab.com/display/EXPRESS/Order+State+Machine

// Instead of having behaviours generated everywhere else, all should be at one place
/**
 * Status map to config
 *
 * Configs should contain the following params
 * - specificPlaybookTypes: string array (optional) - To denote which playbook does this status belong to. By default it should apply to all playbook types.
 * - breadcrumbPriority: number (optional) - The order to display the status as breadcrumb. Starts from 0. If numbers are the same, then we should go by the order which it appear in this config. Will not appear as breadcrumb if this is empty.
 * - specificPlaybookBreadcrumb: string array (optional) - Only works when `breadcrumbPriority` has value. To determine if it should show as breacrumb for specific playbook types.
 * - showMap: boolean (optional) - If true, map will be show (isActive must be true as well)
 * - finalState: boolean (optional) - If true, the status shouldn't change anymore, breadcrumb should not appear anymore
 * - showAsError: boolean (optional) - If true, the progress step should show this as error step
 * - isCancelled: boolean (optional) - Should be true for CANCELLED states. This is used to show proof of cancellation
 * - overrideNextBreadcrumb: string array (optional) - If exist, overrides the existing breadcrumb behaviour with the data in the arrays.
 */
export const STATUS_CONFIG = {
  [QUEUEING]: {
    // Note QUEUEING is not returned from the tracking API (from observations)
    specificPlaybookTypes: [PLAYBOOK_TYPE_ANYTIME_BOOKING],
  },
  [NEW]: {
    // Note NEW is usually not part of anytime booking (unless driver cancels and the playbook retries back as normal booking)
    breadcrumbPriority: 1,
  },
  [PENDING_SCHEDULING]: {
    // Note PENDING_SCHEDULING is not returned from the tracking API (from observations)
  },
  [SCHEDULING]: {
    // Note SCHEDULING is not returned from the tracking API (from observations)
  },
  [SENDER_CANCELLED]: {
    finalState: true,
    showAsError: true,
    isCancelled: true,
  },
  [SCHEDULE_FAILED]: {
    /*
      Note SCHEDULE_FAILED is not returned from the tracking API
      From observations, it will just be false for isActive
      This happens when there is no DAX that can be allocated
    */
    finalState: true,
    showAsError: true,
  },
  [PENDING_PICKUP]: {
    breadcrumbPriority: 4,
  },
  [DRIVER_CANCELLED]: {
    finalState: true,
    showAsError: true,
    isCancelled: true,
  },
  [PICKING_UP]: {
    // This may be removed in the future
    breadcrumbPriority: 5,
    showMap: true,
  },
  [PENDING_DROP_OFF]: {
    breadcrumbPriority: 6,
    showMap: true,
  },
  [DROPPING_OFF]: {
    breadcrumbPriority: 7,
    showMap: true,
  },
  [PENDING_RETURN]: {
    // Normal return flow
    overrideNextBreadcrumb: [RETURNING, RETURNED],
  },
  [RETURNING]: {
    // Normal return flow
    overrideNextBreadcrumb: [RETURNED],
  },
  [RETURNED]: {
    finalState: true,
  },
  [FAILED_DELIVERY]: {
    // Can be either RETURNED or COMPLETED
    overrideNextBreadcrumb: [RETURNED],
    showAsError: true,
  },
  [COMPLETED]: {
    breadcrumbPriority: 8,
    showMap: true,
    finalState: true,
  },
  [OPERATOR_CANCELLED]: {
    finalState: true,
    showAsError: true,
    isCancelled: true,
  },
};
